import {Module} from "../common/Module";
import {isPrivileged} from "../../config/Privileges";

/**
 * associated area name
 */
export const CUSTOMER_AREA_NAME = "customers"

/**
 * CustomerModule
 */
export const CustomerModule: Module = {
    identifier: "customers" ,
    isPrivileged: ( authUser, privilege ) =>
        isPrivileged(
            authUser,
            CUSTOMER_AREA_NAME,
            CustomerModule.identifier,
            privilege
        )
};

/**
 * api route to fetch customers for select components
 * mostly used with fetchSelectOptions
 *
 * @see fetchSelectOptions
 */
export const CUSTOMER_API_SELECT_ROUTE = "customers/select";
